import { EnvironmentGroupId } from '@/react/portainer/environments/types';

import { Directive } from '../../../types';

/**
 * API payload for Docker Cleanup Policy.
 * Property names match the Go JSON tags on DockerCleanupPolicyData exactly.
 * Duration fields are in milliseconds.
 */
export interface DockerCleanupPolicyPayload {
  cleanupInterval: Directive<number>;
  cleanOldImages: Directive<boolean>;
  imageMaximumGCAge: Directive<number>;
  cleanImagesAtStorageLimit: Directive<boolean>;
  highThresholdPercent: Directive<number>;
  lowThresholdPercent: Directive<number>;
  clearBuildCache: Directive<boolean>;
  minAge: Directive<number>;
  maxImagesPerInterval: Directive<number>;
  excludedImages: Directive<Array<string>>;
}

/**
 * Complete form values for Docker Cleanup Policy form.
 * Combines common policy fields (name, environmentGroupIds) with type-specific fields.
 * Duration fields use duration strings (e.g. "3d", "72h", "30m").
 */
export interface DockerCleanupFormValues {
  name: string;
  environmentGroupIds: Array<EnvironmentGroupId>;
  cleanupInterval: string;
  cleanOldImages: boolean;
  imageMaximumGCAge: string;
  cleanImagesAtStorageLimit: boolean;
  highThresholdPercent: number;
  lowThresholdPercent: number;
  clearBuildCache: boolean;
  minAge: string;
  maxImagesPerInterval: number;
  excludedImages: Array<string>;
}

/**
 * Type-specific form data for Docker Cleanup Policy (without common fields).
 */
export interface DockerCleanupFormData {
  cleanupInterval: string;
  cleanOldImages: boolean;
  imageMaximumGCAge: string;
  cleanImagesAtStorageLimit: boolean;
  highThresholdPercent: number;
  lowThresholdPercent: number;
  clearBuildCache: boolean;
  minAge: string;
  maxImagesPerInterval: number;
  excludedImages: Array<string>;
}

export const DOCKER_CLEANUP_INITIAL_VALUES: DockerCleanupFormData = {
  cleanupInterval: '1d',
  cleanOldImages: true,
  imageMaximumGCAge: '20d',
  cleanImagesAtStorageLimit: false,
  highThresholdPercent: 80,
  lowThresholdPercent: 40,
  clearBuildCache: true,
  minAge: '1w',
  maxImagesPerInterval: 0,
  excludedImages: [''],
};

export const DOCKER_CLEANUP_FORM_INITIAL_VALUES: DockerCleanupFormValues = {
  name: '',
  environmentGroupIds: [],
  ...DOCKER_CLEANUP_INITIAL_VALUES,
};
